import { PLATFORMS } from "@/data/site";
import { YouTubeIcon, SpotifyIcon, AppleIcon, AmazonIcon, IHeartIcon, YouTubeMusicIcon } from "@/components/icons/Platforms";
import { ArrowUpRight } from "lucide-react";

const ICONS = {
  YouTube: YouTubeIcon,
  "YouTube Music": YouTubeMusicIcon,
  Spotify: SpotifyIcon,
  "Apple Podcasts": AppleIcon,
  "Amazon Music": AmazonIcon,
  iHeartRadio: IHeartIcon,
};

export default function SubscribeOn({ compact = false, dataTestId = "subscribe-on" }) {
  return (
    <section data-testid={dataTestId} className={compact ? "" : "py-16 md:py-24 border-y border-[#262626] bg-[#0A0A0A]"}>
      <div className={compact ? "" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"}>
        {!compact && (
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
            <div>
              <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#E10600] mb-3">
                Listen Anywhere
              </p>
              <h2 className="font-display text-5xl md:text-6xl uppercase tracking-tight leading-none">
                Subscribe On <span className="text-[#E10600]">Your Platform</span>
              </h2>
            </div>
            <p className="text-zinc-400 max-w-md text-sm md:text-base">
              New drops every Monday. Hit follow on the platform you already use so the
              next episode lands automatically.
            </p>
          </div>
        )}
        <div className={`grid grid-cols-2 ${compact ? "md:grid-cols-5" : "md:grid-cols-5"} gap-px bg-[#262626] border border-[#262626]`}>
          {PLATFORMS.map((p, i) => {
            const Icon = ICONS[p.name];
            return (
              <a
                key={p.name}
                href={p.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`platform-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group bg-[#0A0A0A] p-5 md:p-6 hover:bg-[#121212] transition-colors flex items-center gap-4 relative"
              >
                {Icon && (
                  <Icon
                    className="w-8 h-8 md:w-10 md:h-10 flex-shrink-0 transition-colors"
                    style={{ color: p.color }}
                  />
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-display text-xl md:text-2xl uppercase leading-none text-white group-hover:text-[#E10600] transition-colors">
                    {p.name}
                  </p>
                  <p className="text-[10px] tracking-[0.15em] uppercase font-mono text-zinc-500 mt-1 truncate">
                    {p.handle}
                  </p>
                </div>
                <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-[#E10600] flex-shrink-0 transition-colors" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
